"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _hookForm = require('shared/services/validation/hookForm');


var _joi = require('shared/services/validation/joi'); var _joi2 = _interopRequireDefault(_joi);
var _uuid = require('shared/services/uuid');






const defaultReferrers = [
  'Internet search',
  'ChatGPT or AI recommendation',
  'Invitation from friend',
  'A colleague referred me',
  'Facebook or community group',
  'Software review site (G2, Capterra)',
  'Conference or trade show',
]

 const OTHER_OPTION_KEY = 'other'; exports.OTHER_OPTION_KEY = OTHER_OPTION_KEY
const optionOther = { value: exports.OTHER_OPTION_KEY, label: 'Other (please specify)' }

const makeForm = (labels, fieldDisplayName, placeholder) => {
  const actualOptions = labels.map(o => ({ value: _uuid.uuidv4.call(void 0, ), label: o }))
  // The empty-value option is the select's placeholder: shown while nothing is
  // chosen (and hidden from the open list), never a submittable answer.
  const options = [{ value: '', label: placeholder }]
    .concat(actualOptions)
    .concat(optionOther)

  const schema = _joi2.default.object({
    response: _joi.requiredString.call(void 0, ),
    // "Other" needs saying what it is: an empty answer is an error.
    responseOther: _joi2.default.when(
      'response', {
        is: exports.OTHER_OPTION_KEY,
        then: _joi.requiredString.call(void 0, ),
        otherwise: _joi2.default.forbidden(),
      },
    ).messages({ ..._joi.makeStrErrors.call(void 0, fieldDisplayName), 'any.required': 'Tell us where you heard about BloomText.', 'string.empty': 'Tell us where you heard about BloomText.' }),
  })

  const resolver = _hookForm.joiResolver.call(void 0, schema, {}, { mode: 'sync' })
  return [options, resolver] 
}

const [referrerOptions, referrerResolver] =
  makeForm(defaultReferrers, 'Referrer', 'Select an option…')

 const parseResponse = (data) => {
  const response = data.response === exports.OTHER_OPTION_KEY
    ? data.responseOther
    : _optionalChain([referrerOptions, 'access', _ => _.find, 'call', _2 => _2(o => o.value === data.response), 'optionalAccess', _3 => _3.label])

  return response || ''
}; exports.parseResponse = parseResponse




exports.referrerOptions = referrerOptions; exports.referrerResolver = referrerResolver;
